import { environment } from '@environments/environment';
import { IStepOption } from 'ngx-ui-tour-md-menu';

export const tourStation = environment.tourStation;
//export const tourStation = {
//  stationId: 5321,
//  latitude: 53.916342,
//  longitude: -1.277242,
//};

export const tourSteps: IStepOption[] = [
  {
    anchorId: 'welcome-tour-step',
    title: 'Let’s Take a Quick Tour',
    content: 'We’ll show you the key features to help you get familiar with finding stations, starting a charge, and managing your account!',
    placement: {
    }
  },
  {
    anchorId: 'app-sidebar',
    title: 'Sidebar Navigation',
    content: 'Access the map, navigation, and more, right from the sidebar.',
    placement: {
      horizontal: true,
    }
  },
  {
    anchorId: 'app-search',
    title: 'Search',
    content: 'Quickly search by station name or address to find the perfect spot to plug in.',
    placement: {
      horizontal: false,
      xPosition: 'after',
    },
  },
  {
    anchorId: 'marker-tour-step',
    title: 'Station Marker',
    content: 'Tap a station marker to view availability, charger types, and much more info.',
    placement: {
      horizontal: false,
      yPosition: 'below',
    }
  },
];

export const tourSteps2: IStepOption[] = [
  {
    anchorId: 'station-details-tour-step',
    title: 'Station Details',
    content: 'Get real-time info on charger status, pricing, amenities, and more, all in one view.',
    placement: {
      horizontal: true,
      xPosition: 'after',
    }
  },
  {
    anchorId: 'user-dropdown-tour-step',
    title: 'Login',
    content: 'Save your favorite stations, track usage, and manage payment options by logging in.',
    placement: {
      horizontal: true,
      xPosition: 'after',
    }
  },
]
